$(document).ready(function () {
  const minInputLength = 3;
  const currentLocale = getCurrentLocale();
  const errorMessage = {
    fr: 'Veuillez entrer ' + minInputLength + ' caractères min.',
    en: 'Please enter ' + minInputLength + ' or more characters.',
    es: 'Por favor, introduzca ' + minInputLength + ' o más caracteres.',
  };

  if ($('.select2').length) {
    $('.select2').select2({
      minimumInputLength: minInputLength,
      language: {
        inputTooShort: function () {
          return errorMessage[currentLocale];
        }
      }
    });
  }

  const asset_management_advisor_select = $('#user_asset_management_advisor_id');

  if (asset_management_advisor_select.length) {
    const initAssetManagementAdvisorSelect = function () {
      if (asset_management_advisor_select.data('select2') !== undefined) {
        asset_management_advisor_select.select2('destroy');
      }

      asset_management_advisor_select.select2({
        allowClear: true,
        placeholder: '',
        dropdownAutoWidth: true,
        width: '100%',
        language: {
          inputTooShort: function () {
            return errorMessage[currentLocale];
          }
        },
        ajax: {
          url: asset_management_advisor_select.data('index-url'),
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term
            };
          },
          processResults: function (data) {
            if (data.length == 0 || data.length === undefined) {
              return { results: [] };
            }

            const asset_management_advisor_profiles = $.map(data, function (profile) {
              return {
                'id': profile.id,
                'text': profile.company_name
              };
            });

            return { results: asset_management_advisor_profiles };
          },
          cache: true
        },
        minimumInputLength: minInputLength
      });

      const showUrl = asset_management_advisor_select.data('show-url');

      if (showUrl != undefined && showUrl.length) {
        // Fetch the preselected item, and add to the select2
        $.ajax({
          type: 'GET',
          url: showUrl,
          dataType: 'json'
        }).then(function (data) {
          const option = new Option(data.company_name, data.id, true, true);
          asset_management_advisor_select.append(option).trigger('change');

          // manually trigger the `select2:select` event
          asset_management_advisor_select.trigger({
            type: 'select2:select',
            params: {
              data: data
            }
          });
        });
      }
    };

    // If inside a Bootstrap collapse, wait until it's visible to initialize
    const $collapse = asset_management_advisor_select.closest('.collapse');
    if ($collapse.length) {
      $collapse.on('shown.bs.collapse', initAssetManagementAdvisorSelect);
    } else {
      initAssetManagementAdvisorSelect();
    }
  }

  $('.form-select:not(.select2)').each(function () {
    const $el = $(this);
    if ($el.data('select2') !== undefined) return;
    const options = { minimumResultsForSearch: Infinity, width: '100%' };
    if ($el.find('option[value=""]').length) {
      options.placeholder = ' ';
    }
    $el.select2(options);
  });

  // Bridge Select2 jQuery events to native DOM events so Stimulus controllers can listen with addEventListener
  $(document).on('select2:select select2:unselect', '.form-select', function() {
    this.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
